import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { WorkspaceUserRoleId } from './workspaceSliceTypes'

const ACL_ROLE_PRIORITY: Record<WorkspaceUserRoleId, number> = {
  'id:owner': 1,
  'id:content:editor': 2,
  'id:viewer': 3,
}

export const selectWorkspaces = (state: RootState) => state.workspace.entities

export const selectWorkspacesSortedByRole = createSelector(
  selectWorkspaces,
  (workspaces) =>
    workspaces.toSorted(
      (a, b) => ACL_ROLE_PRIORITY[a.aclRoleId] - ACL_ROLE_PRIORITY[b.aclRoleId],
    ),
)

export const selectWorkspaceIds = createSelector(
  selectWorkspaces,
  (workspaces) => workspaces.map((workspace) => workspace.id),
)

export const selectWorkspacesStatus = (state: RootState) =>
  state.workspace.status

export const selectWorkspacesError = (state: RootState) => state.workspace.error

export const selectWorkspaceById = (workspaceId: string | null) =>
  createSelector(selectWorkspaces, (workspaces) =>
    workspaceId
      ? workspaces.find((workspace) => workspace.id === workspaceId)
      : null,
  )

export const selectSelectedWorkspaceId = (state: RootState) =>
  state.workspace.selectedWorkspaceId

export const selectMyWorkspaceId = (state: RootState) =>
  state.workspace.myWorkspaceId

export const selectSelectedWorkspace = (state: RootState) => {
  const selectedWorkspaceId = state.workspace.selectedWorkspaceId
  return state.workspace.entities.find(
    (workspace) => workspace.id === selectedWorkspaceId,
  )
}

export const selectSelectedWorkspaceName = createSelector(
  selectSelectedWorkspace,
  (workspace) => workspace?.name,
)

export const selectSelectedWorkspaceAvatar = createSelector(
  selectSelectedWorkspace,
  (workspace) => workspace?.avatar,
)
